import { Typography, Box } from "@mui/material";

const Footer = () => (
    <Box
        id="footer"
        style={{
            height: '7vh',
            display: "flex",
            justifyContent: "center",
            alignItems: 'center'
        }}
    >
        <Typography fontSize='15px'>
            Copyright <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 100 }}>© GC Builders</span> 2024
        </Typography>
    </Box>
);

export default Footer;